import React, { useState } from 'react';
import MediaQuery from 'react-responsive';
import Mobile from './Mobile';
import Desktop from './Desktop';



export default function Header(props) {
    const [ open, setOpen ] = useState(false);

    const handleClick = props => { 

    }

    return (
        <React.Fragment>
            <header>
                <MediaQuery maxWidth={600}>
                    <Mobile />
                </MediaQuery>
                <MediaQuery minWidth={601}>
                    <Desktop />
                </MediaQuery>
            </header>
           
        </React.Fragment>
    )

}
